import React from 'react'
import BlogSidebar from './BlogSidebar'
import ArticleHeader from './ArticleHeader'
import ArticleContent from './ArticleContent'
import Img from '@/lib/Img'

const BlogPostContent = ({ post, location }) => (
	<section className="section grid md:grid-cols-[150px,1fr] gap-y-8 gap-x-4 border-b border-grounding-navy/10">
		<BlogSidebar location={location} />

		<article className='max-w-screen-lg mx-auto'>
			<ArticleHeader post={post} />

			{!post.thumbnailOnly && (
				<figure className="my-8 text-center">
					<Img
						className="max-h-[80vh]"
						objectFit="contain"
						image={post.featuredImage}
						alt={post.title}
					/>
					{post.excerpt && (
						<figcaption className="text-grounding-navy/50 mt-4">{post.excerpt}</figcaption>
					)}
				</figure>
			)}

			<ArticleContent content={post._rawContent} />
		</article>
	</section>
)

export default BlogPostContent
